var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Button',{directives:[{name:"b-modal",rawName:"v-b-modal.customized-modal",modifiers:{"customized-modal":true}}],staticClass:"right-side"},[_vm._v("Create Period")]),_c('b-modal',{attrs:{"id":"customized-modal","title":"Create Period","no-close-on-backdrop":"","centered":""},on:{"ok":function (evt) {
        var temp = _vm.$emit('onSubmit', this$1.form);
        // Hide the modal manually
        this$1.$nextTick(function () {
          this$1.$bvModal.hide('modal-prevent-closing');
        });
      }}},[_c('b-form-group',{attrs:{"label":"Period of the review session","label-for":"id-period"}},[_c('b-form-select',{attrs:{"id":"id-period","options":_vm.options},model:{value:(_vm.form.period),callback:function ($$v) {_vm.$set(_vm.form, "period", $$v)},expression:"form.period"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }